import { render, staticRenderFns } from "./Levels.vue?vue&type=template&id=31c183a8&scoped=true&"
import script from "./Levels.vue?vue&type=script&lang=js&"
export * from "./Levels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c183a8",
  null
  
)

export default component.exports